<div class="d-flex flex-column gap-3 h-100">
  <div class="d-flex align-items-center">
    <h3 class="mb-0">Co Buyers</h3>
    <button class="btn btn-primary btn-h42 ms-auto" (click)="openAddCoBuyerModal()">
      <i class="bi bi-person-plus fs-16"></i>
      Add Co-Buyer
    </button>
  </div>

  <div class="flex-fill overflow-y-auto">
    <div class="table-outer table-theme">
      <div class="table-responsive h-100 table-deposits">
        <p-table [value]="coBuyers()">
          <ng-template #header>
            <tr>
              <th pSortableColumn="firstName">Name <p-sortIcon field="firstName" /></th>
              <th>Phone Number</th>
              <th pSortableColumn="email">Email <p-sortIcon field="email" /></th>
              <!-- <th>Created Date</th> -->
              <th>Add to Mailing List</th>
              <th>Include in Contract</th>
              <th>Status</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template #body let-coBuyer>
            <tr>
              <td class="position-relative">
                <i class="bi bi-person-workspace fs-16 me-1"></i>
                <span>{{ getFullName(coBuyer) }}</span>
              </td>
              <td>
                @if (coBuyer.phone) {
                  <phone-numbers-display [contacts]="getPhoneContacts(coBuyer)"></phone-numbers-display>
                } @else {
                  <span class="text-muted">-</span>
                }
              </td>
              <td>
                @if (coBuyer.email) {
                  <a [href]="'mailto:' + coBuyer.email" class="text-decoration-none">{{ coBuyer.email }}</a>
                } @else {
                  <span class="text-muted">-</span>
                }
              </td>
              <!-- <td>
                @if (coBuyer.createdByUserName) {
                  {{ coBuyer.createdByUserName }}
                } @else {
                  <span class="text-muted">-</span>
                }
              </td> -->
              <!-- <td>
                @if (coBuyer.createdAt) {
                  {{ coBuyer.createdAt | date }}
                } @else {
                  <span class="text-muted">-</span>
                }
              </td> -->
              <td>
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [id]="'addToMailingList-' + coBuyer.id"
                    [checked]="coBuyer.addToMailingList"
                    (change)="onToggleAddToMailingList(coBuyer, $event)"
                  />
                  <label class="form-check-label" [for]="'addToMailingList-' + coBuyer.id">
                    @if (coBuyer.addToMailingList) {
                      <span class="text-success">Yes</span>
                    } @else {
                      <span class="text-muted">No</span>
                    }
                  </label>
                </div>
              </td>
              <td>
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [id]="'includeInContract-' + coBuyer.id"
                    [checked]="coBuyer.includeInContract"
                    (change)="onToggleIncludeInContract(coBuyer, $event)"
                  />
                  <label class="form-check-label" [for]="'includeInContract-' + coBuyer.id">
                    @if (coBuyer.includeInContract) {
                      <span class="text-success">Yes</span>
                    } @else {
                      <span class="text-muted">No</span>
                    }
                  </label>
                </div>
              </td>
              <td>
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [id]="'status-' + coBuyer.id"
                    [checked]="coBuyer.isActive"
                    (change)="toggleCoBuyerStatus(coBuyer, $event)"
                    [disabled]="!coBuyer.id"
                  />
                  <label class="form-check-label" [for]="'status-' + coBuyer.id">
                    @if (coBuyer.isActive) {
                      <span class="text-success">Active</span>
                    } @else {
                      <span class="text-muted">Inactive</span>
                    }
                  </label>
                </div>
              </td>
              <td>
                <button
                  type="button"
                  class="text-decoration-none border-0 bg-transparent"
                  (click)="openEditCoBuyerModal(coBuyer.id!)"
                  [disabled]="!coBuyer.id"
                  [ngbTooltip]="'Edit'"
                  placement="top"
                >
                  <i class="bi bi-pencil-square"></i>
                </button>
              </td>
            </tr>
          </ng-template>
          @if (coBuyers().length === 0) {
            <ng-template #emptymessage>
              <tr>
                <td colspan="7" class="text-center py-4">
                  <span class="text-muted">No co-buyers found</span>
                </td>
              </tr>
            </ng-template>
          }
        </p-table>
      </div>
    </div>
  </div>

  <ng-template #addCoBuyerModal let-modal>
    @if (prospectId()) {
      <add-co-buyer-modal
        [prospectIdInput]="prospectId()!"
        [(selectedCoBuyerInput)]="selectedCoBuyer"
        (reload)="onCoBuyerReload()"
      ></add-co-buyer-modal>
    }
  </ng-template>
</div>
